import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    /**
     * Assíncrono: aguarda a restauração da sessão (refresh via cookie) antes de decidir.
     * O access token vive só em memória e se perde no reload, então decidir sem esperar
     * derrubaria para o /login todo F5 em rota profunda — a sessão existe, só ainda não
     * foi restaurada. A restauração é memoizada, então isto não dispara refresh extra.
     */
    async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        await this.authService.initAuth();
        if (this.authService.isLoggedIn) {
            return true;
        }
        return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }
}
